import React from "react";
import { getImageUrl, linkName } from "../../../utils/generalLiveCenter";

import NextImage from "../../common/NextImage";
import NoDataFound from "../../common/NoDataFound";

const LeagueTeamTable = ({ data, dictionary = {}, sport = "football" }) => {
  const sortedData = [...(data || [])]
    ?.sort((a, b) => (a?.name || "")?.localeCompare(b?.name || ""))
    ?.slice(0, 20);

  return (
    <div className="global_table team_table">
      {sortedData?.length ? (
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>{dictionary?.teams || "Teams"}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {sortedData?.map((row, index) => {
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    <div className="des-wrap">
                      <span className="flg_img">
                        <NextImage
                          src={getImageUrl('', '', sport, row?.tid)}
                          height={23}
                          width={23}
                          alt="teamLogo"
                          priority={false}
                        />
                      </span>
                      <span className="des-text">{row?.name}</span>
                    </div>
                  </td>
                  <td>
                    <ul>
                      <li>
                        <a
                          href={`/${sport}/team/${linkName(row?.name)}/${row?.id
                            }/info`}
                        >
                          Fixtures
                        </a>
                      </li>
                      <li>
                        <a
                          href={`/${sport}/team/${linkName(row?.name)}/${row?.id
                            }/stats`}
                        >
                          Stats
                        </a>
                      </li>
                    </ul>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <NoDataFound />
      )}
    </div>
  );
};

export default LeagueTeamTable;
